// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1lKmF","col":"CardReaderDesc_col__2iatN","label":"CardReaderDesc_label__qwoDh"};